import styled from "styled-components";

export const PlaylistContainer = styled.div`
    margin-top: 30px;
`;

export const PlaylistTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PlaylistTitleLoadMore = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    width: 250px;
    gap: 10px;
    font-size: 19.2px;
    cursor: pointer;
    transition: font-size 0.1s ease-in-out;

    &:hover {
        font-size: 20.8px;
    }
`;

export const PlaylistTitle = styled.div`
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
    width: 100%;
`;

export const PlaylistDescription = styled.div`
    font-size: 19.2px;
    margin-bottom: 20px;
    width: 70%;
    transition: height 0.5s ease-in-out;
`;

export const ExpandButton = styled.button`
    font-size: 16px;
    color: #007bff;
    background-color: transparent;
    border: none;
    cursor: pointer;
`;
